import { RuleStatus } from 'api-models'

export interface RuleExecution {
	ruleId: string
	ruleName: string
	level: string
	status: RuleStatus
	adPlatform?: string
	executions: number
	dailyCounts?: Array<{ date: string; count: number }>
	blockedSources: number
	dailyBlockedSources?: Array<{ date: string; count: number }>
	deletedAt?: Date
}

export interface DailyExecution {
	date: string
	[key: string]: string | number
}

export type RuleAnalysisMetric = 'executions' | 'blockedSources'

export interface StatusOption {
	label: string
	value: RuleStatus
}

export const statusOptions: StatusOption[] = [
	{ label: 'Active', value: RuleStatus.ACTIVE },
	{ label: 'Inactive', value: RuleStatus.PAUSED },
	{ label: 'Deleted', value: RuleStatus.DELETED }
]
import { RuleFormType } from '../rule-form/types'

export interface UseTableColumnsProps {
	selectedRules: Set<string>
	sortedRules: RuleExecution[]
	dateRange: { from: Date; to: Date }
	handleRuleToggle: (ruleId: string) => void
	setSelectedRules: (rules: Set<string>) => void
	level: any
	targetId?: string | null
	targetName?: string | null
	platform?: any
	refetchExecutions: () => void
	rulesMap: Map<string, RuleFormType>
}

export interface RuleExecutionQuery {
	asset_id: string
	from?: number
	to?: number
	status?: string
	search?: string
	sort?: string
}

